import { Button, Grid, IconButton, MenuItem, TextField, Tooltip } from "@material-ui/core";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import AgregarFolios from "./AgregarFolios";
import CargarArchivo from "./CargarArchivo";
import CreateNewFolderIcon from "@material-ui/icons/CreateNewFolder";
import DeleteIcon from "@material-ui/icons/Delete";
import DetalleArchivoVerificado from "./DetalleArchivoVerificado";
import EliminarFolios from "./EliminarFolios";
import EventAvailableRoundedIcon from "@material-ui/icons/EventAvailableRounded";
import FolioHelper from "../../folio/FolioHelper";
import { Fragment } from "react";
import GetAppIcon from "@material-ui/icons/GetApp";
import MeditocActions from "../../../utils/MeditocActions";
import MeditocModalFull from "../../../utils/MeditocModalFull";
import MeditocTableSelection from "../../../utils/MeditocTableSelection";
import ModificarVigencia from "./ModificarVigencia";
import NoteAddRoundedIcon from "@material-ui/icons/NoteAddRounded";
import RefreshIcon from "@material-ui/icons/Refresh";
import { getAdministrarEmpresaColumns } from "../../../../models/EmpresaModel";
import { useCatalogo } from "../../../../context/CatalogoContext";
import { useEmpresa } from "../../../../context/EmpresaContext";
import { useLogin } from "../../../../context/LoginContext";
import { useStyle } from "../../../../context/StyleContext";

export default function AdministrarEmpresa() {
    const { classes } = useStyle();
    const { usuarioPermisos } = useLogin();
    const { entCatalogos } = useCatalogo();
    const {
        listaProductos,
        listaFolios,
        triggerListaFolios,
        empresaSeleccionada,
        foliosSeleccionados,
        modalOpenAdministrarEmpresa,
        formFiltroFolios,
        handleOpenAdministrarEmpresa,
        handleChangeListaFolios,
        handleChangeFoliosSeleccionados,
        handleChangeFormFiltroFolios,
        handleClickAgregarFolios,
        handleClickModificarVigencia,
        handleClickSubirArchivo,
        handleClickDescargarPlantilla,
        handleClickEliminarFolios,
        handleClickRefrescarDatosFolios,
        handleClickFiltrarFolios,
    } = useEmpresa();

    const permisos = usuarioPermisos["2"].Submodulos["2"];
    const { txtOrigen, txtProducto, txtVigente } = formFiltroFolios;

    return (
        <Fragment>
            <MeditocModalFull
                open={modalOpenAdministrarEmpresa}
                setopen={handleOpenAdministrarEmpresa}
                title={`Administrar folios de ${empresaSeleccionada.sNombre} (${empresaSeleccionada.sFolioEmpresa})`}
            >
                <MeditocActions title={`Folios generados: ${listaFolios.length}`}>
                    {permisos.Botones["5"] && ( //Crear folios a empresa
                        <Tooltip title={permisos.Botones["5"].Nombre} arrow>
                            <IconButton onClick={handleClickAgregarFolios}>
                                <NoteAddRoundedIcon className="color-1" />
                            </IconButton>
                        </Tooltip>
                    )}
                    {permisos.Botones["6"] && ( //Modificar vigencia a folios seleccionados
                        <Tooltip title={permisos.Botones["6"].Nombre} arrow>
                            <IconButton onClick={handleClickModificarVigencia}>
                                <EventAvailableRoundedIcon className="color-1" />
                            </IconButton>
                        </Tooltip>
                    )}
                    {permisos.Botones["7"] && ( //Cargar folios desde archivo
                        <Tooltip title={permisos.Botones["7"].Nombre} arrow>
                            <IconButton onClick={handleClickSubirArchivo}>
                                <CreateNewFolderIcon className="color-1" />
                            </IconButton>
                        </Tooltip>
                    )}
                    {permisos.Botones["8"] && ( //Descargar plantilla para cargar folios desde archivo
                        <Tooltip title={permisos.Botones["8"].Nombre} arrow>
                            <IconButton onClick={handleClickDescargarPlantilla}>
                                <GetAppIcon className="color-1" />
                            </IconButton>
                        </Tooltip>
                    )}
                    {permisos.Botones["9"] && ( //Eliminar folios seleccionados
                        <Tooltip title={permisos.Botones["9"].Nombre} arrow>
                            <IconButton onClick={handleClickEliminarFolios}>
                                <DeleteIcon className="color-1" />
                            </IconButton>
                        </Tooltip>
                    )}
                    {permisos.Botones["10"] && ( //Actualizar tabla de folios
                        <Tooltip title={permisos.Botones["10"].Nombre} arrow>
                            <IconButton onClick={handleClickRefrescarDatosFolios}>
                                <RefreshIcon className="color-1" />
                            </IconButton>
                        </Tooltip>
                    )}
                </MeditocActions>
                <Grid container spacing={2}>
                    <Grid item sm={4} xs={12}>
                        <TextField
                            name="txtOrigen"
                            label={txtOrigen.label}
                            value={txtOrigen.value}
                            onChange={handleChangeFormFiltroFolios}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                            select
                        >
                            <MenuItem value="">Todos</MenuItem>
                            {entCatalogos.catOrigen.map((origen) => (
                                <MenuItem value={origen.fiId.toString()}>{origen.fsDescripcion}</MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <TextField
                            name="txtProducto"
                            label={txtProducto.label}
                            value={txtProducto.value}
                            onChange={handleChangeFormFiltroFolios}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                            select
                            SelectProps={{
                                MenuProps: {
                                    classes: {
                                        paper: classes.selectMain,
                                    },
                                    PaperProps: {
                                        style: { maxHeight: 400 },
                                    },
                                },
                            }}
                        >
                            <MenuItem value="">Todos los productos</MenuItem>
                            {listaProductos.map((producto) => (
                                <MenuItem key={producto.iIdProducto} value={producto.iIdProducto.toString()}>
                                    <i
                                        className="icon size-20"
                                        dangerouslySetInnerHTML={{
                                            __html: `&#x${producto.sIcon};&nbsp;&nbsp;&nbsp;`,
                                        }}
                                    />
                                    {"   "}
                                    {producto.sNombre}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <TextField
                            name="txtVigente"
                            label={txtVigente.label}
                            value={txtVigente.value}
                            onChange={handleChangeFormFiltroFolios}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                            select
                        >
                            <MenuItem value="">Todos los folios</MenuItem>
                            <MenuItem value="true">Folio activo</MenuItem>
                            <MenuItem value="false">Folio inactivo/vencido</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={12} className="right">
                        <Button
                            variant="contained"
                            style={{ color: "#555", marginRight: 15 }}
                            onClick={handleClickRefrescarDatosFolios}
                        >
                            Limpiar
                        </Button>
                        <Button variant="contained" color="primary" onClick={handleClickFiltrarFolios}>
                            Filtrar
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <MeditocTableSelection
                            id="iIdFolio"
                            data={listaFolios}
                            rows={foliosSeleccionados}
                            trigger={triggerListaFolios}
                            setData={handleChangeListaFolios}
                            columns={getAdministrarEmpresaColumns()}
                            setRows={handleChangeFoliosSeleccionados}
                        />
                    </Grid>
                </Grid>
                <FolioHelper />
            </MeditocModalFull>
            <AgregarFolios />
            <ModificarVigencia />
            <CargarArchivo />
            <DetalleArchivoVerificado />
            <EliminarFolios />
        </Fragment>
    );
}
